export default "__VITE_ASSET__6e2c7ece__"